import { getPaymentDisplay } from "../../utils/paymentGateway";
import "./PaymentGatewayLabel.css";

// Gateway logo + name (+ card digits when known) for an order row.
const PaymentGatewayLabel = ({ order }) => {
  const { label, logo, last4 } = getPaymentDisplay(order);

  return (
    <span className="pgw-label" data-testid="payment-gateway">
      {logo && <img src={logo} alt="" className="pgw-logo" />}
      <span className="pgw-name">{label}</span>
      {last4 && <span className="pgw-digits">•••• {last4}</span>}
    </span>
  );
};

export default PaymentGatewayLabel;
